import {customAxiosBE} from "../config";

export async function getAllVATS_API() {
    return customAxiosBE.get(`/firebase/vats`)
}

/**
 * Dohvata stavke za izdavanje karata sa cenama iz aktivnog cenovnika.
fg * Backend filtrira: includeOnIssuingTicket=true, inactive=false i locationPac
 */
export async function getItemsForSaleAPI(locationPac) {
    const params = locationPac ? { locationPac } : {};
    return customAxiosBE.get(`/firebase/items-for-sale`, { params })
}
